import React from "react";
import GridSection, { GridSectionValue } from "./GridSection";

export interface GridLayoutValue
{
    sections: GridSectionValue[];
}
interface GridValueProps
{
    layout: GridLayoutValue | undefined;
}

const GridLayout: React.FunctionComponent<GridValueProps> = (props) =>
{
    if (!props.layout)
    {
        return null;
    }

    const { sections } = props.layout;

    if (!sections)
    {
        return null;
    }

    if (sections.length > 1)
    {
        return (
            <div>TODO: Multiple sections</div>
        );
    }

    return <GridSection section={sections[0]} />;
};

export default GridLayout;